import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { breakWidth480 } from "@churchofjesuschrist/eden-style-constants";
import EdenImage from "@churchofjesuschrist/eden-image";
const Image = styled(EdenImage).withConfig({
  componentId: "sc-1qycwea-0"
})(["@media (min-width:", "){position:absolute;top:0;right:0;width:100%;height:100%;object-fit:scale-down;}"], breakWidth480); // title, caption, and attribution are read and displayed by the MediaModal, but attached to this component.

const ModalImage = _ref => {
  let { ...props
  } = _ref;
  delete props.caption;
  delete props.attribution;
  return /*#__PURE__*/React.createElement(Image, props);
};

ModalImage.propTypes = {
  /** Title to display with the image */
  title: PropTypes.string,

  /** Caption to display with the image */
  caption: PropTypes.node,

  /** Attribution or copyright */
  attribution: PropTypes.node,

  /** Image source */
  src: PropTypes.string.isRequired
};
export default ModalImage;